import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  documents: [],
  property: {},
  applicationId: null,
  applicationType: '',
  contractDetails: {},
  PropertyContractDetails: {},
  terminationDetails: {
    terminationType: '',
    paidAmount: 0,
    buyers: [],
    owners: [],
  },
  bankDetails: {
    isDraft: false,
    buyers: [],
    owners: [],
  },
};

export default function OffPlanTerminationReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.OFFPLAN_TERMINATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.OFFPLAN_TERMINATION_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.CLEAR_OFFPLAN_TERMINATION_APPLICATION_ERROR:
      return {
        ...state,
        error: null,
      };

    case types.FETCH_APPLICATION_OFFPLAN_TERMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
        terminationDetails: {
          ...state.terminationDetails,
          terminationType: get(action.payload, 'terminationType', ''),
          paidAmount: get(action.payload, 'paidAmount', 0),
          buyers: get(action.payload, 'buyers', []),
          owners: get(action.payload, 'owners', []),
        },
        bankDetails: {
          ...state.bankDetails,
          buyers: get(action.payload, 'buyers', []),
          owners: get(action.payload, 'owners', []),
        },
      };
    case types.FETCH_PROPERTY_OFFPLAN_TERMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
        property: get(action.payload, 'property', {}),
      };

    case types.FETCH_DOCUMENTS_OFFPLAN_TERMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', []),
      };

    case types.INITIATE_OFFPLAN_TERMINATION_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
      };

    case types.CHANGE_OFFPLAN_TERMINATION_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };

    case types.DOWNLOAD_DOCUMENT_OFFPLAN_TERMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.ADD_TO_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };

    case types.SAVE_APPLICATION_OFFPLAN_TERMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
        // application: get(action.payload, 'application', {}),
        error: null,
      };

    case types.OFFPLAN_TERMINATION_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }

    case types.CHECKOUT_OFFPLAN_TERMINATION_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_OFFPLAN_TERMINATION_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeStep: 0,
      };

    // post flow

    case types.APPROVAL_OFFPLAN_TERMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case types.POST_RETURN_OFFPLAN_TERMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case types.OFFPLAN_TERMINATION_CLEAR_DATA:
      return defaultState;

    case types.DOWNLOAD_OFFPLAN_TERMINATION_CONTRACT_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.UPLOAD_OFFPLAN_TERMINATION_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };

    case types.FETCH_OFFPLAN_TERMINATION_PROPERTY_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        PropertyContractDetails: action.payload,
      };
    case types.UPDATE_TERMINATION_DETAILS:
      return {
        ...state,
        terminationDetails: { ...state.terminationDetails, ...action.payload },
      };

    case types.UPDATE_BANK_DETAILS:
      return {
        ...state,
        bankDetails: { ...state.bankDetails, ...action.payload },
      };
    default:
      return state;
  }
}
